import React, { useEffect, useState, useRef, useCallback } from 'react';
import Select from 'react-select';
import "./priceComp.css"
import ApiService from '../../services/apiService';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { RxCross2 } from "react-icons/rx";
import { clearComparison, setComparison } from '../../../Redux/actions/comparisonAction';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getCompany, getComparison, getName, getUserId, getUserName } from '../../../Redux/selecters';
import { RiRefreshLine } from "react-icons/ri";
import { FaAngleLeft } from "react-icons/fa6";
import { FaSave } from "react-icons/fa";
import { ClipLoader } from 'react-spinners';
import Modal from 'react-bootstrap/Modal';
import AuthorizationList from './authorization';
import MessageList from './messageList';
import moment from 'moment';
import Attachment from '../Attachment/attachment';
import UpdateAttachment from '../Attachment/UpdateAttachment';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';



const createEmptyRow = () => ({
    id: Date.now() + Math.random(),
    file: null,
    fileName: "",
    remarks: "",
});
const PriceCompCreate = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState(0);
    const { currencyPrecision } = useCurrency();
    const [gridVisibility, setGridVisibility] = useState([true, false, false]);
    const compare = useSelector(state => state.comparison.rows);
    const CompareData = location.state || compare;
    const userId = useSelector(getUserId);
    const userName = useSelector(getUserName);
    const Company = useSelector(getCompany);
    const [suppliersTotals, setSuppliersTotals] = useState({});
    const [loader, setLoader] = useState(false);
    const [quotationData, setQuotationData] = useState([]);
    const topDivRef = useRef(null);
    const bottomDivRef = useRef(null);
    const [usersDetails, setUser] = useState([]);
    let navigate = useNavigate();
    const [suppliers, setSupplier] = useState([]);
    const [payments, setPayments] = useState([]);

    // Attachment
    const [attachmentModal, setAttachmentModal] = useState(false);
    const [previewModal, setPreviewModal] = useState(false);
    const [preview, setPreview] = useState();
    const [previewImage, setPreviewImage] = useState(null);
    const [attachments, setAttachments] = useState([createEmptyRow()]);
    const openModal = () => setAttachmentModal(true);
    const closeModal = () => setAttachmentModal(false);
    const isReadOnly = CompareData?.eye === true;

    const [formData, setFormData] = useState({
        QuoteNo: "",
        RequisitionNo: "",
        remarks: "",
        costCenter1: "",
        costCenter2: "",
        costCenter3: "",
        costCenter4: "",
        quotation: [
            { refNo: "", paymentTerms: "", supplier: "", remarks: "" },
            { refNo: "", paymentTerms: "", supplier: "", remarks: "" },
            { refNo: "", paymentTerms: "", supplier: "", remarks: "" },
        ]
    });
    const initialQuotations = [
        { qty: "", unitPrice: "", amount: "", supplier: { label: "Select Supplier", value: "Select Supplier" }, supplierId: "", paymentTerms: "" },
        { qty: "", unitPrice: "", amount: "", supplier: { label: "Select Supplier", value: "Select Supplier" }, supplierId: "", paymentTerms: "" },
        { qty: "", unitPrice: "", amount: "", supplier: { label: "Select Supplier", value: "Select Supplier" }, supplierId: "", paymentTerms: "" }
    ];
    const initialRow = {
        srno: '',
        ItemNo: '',
        itemDescription: '',
        Specs: '',
        qty: '',
        uom: '',
        baseQty: '',
        baseAmount: '',
        amount: '',
        Delivery: '',
        bol: '',
        quotations: initialQuotations,
    };
    useEffect(() => {
        if (topDivRef.current) {
            topDivRef.current.scrollLeft = topDivRef.current.scrollWidth;
        }
    }, [formData.quotation.length]);
    const [rows, setRows] = useState([initialRow]);
    const [RequisitionNo, setRequisitionNo] = useState();
    const [QuotationNo, setQuotationNo] = useState();
    const [SupplierTab, setSupplierTab] = useState(true);
    const apiService = new ApiService()
    const [docModal, setDocModal] = useState(false);
    const onOpenModal = () => setDocModal(true);
    const onCloseModal = () => setDocModal(false);
    useEffect(() => {
        const topDiv = topDivRef.current;
        const bottomDiv = bottomDivRef.current;
        const syncScroll = (source, target) => {
            target.scrollLeft = source.scrollLeft;
        };

        const handleTopScroll = () => syncScroll(topDiv, bottomDiv);
        const handleBottomScroll = () => syncScroll(bottomDiv, topDiv);
        if (topDiv && bottomDiv) {
            topDiv.addEventListener('scroll', handleTopScroll);
            bottomDiv.addEventListener('scroll', handleBottomScroll);
        }
        return () => {
            if (topDiv && bottomDiv) {
                topDiv.removeEventListener('scroll', handleTopScroll);
                bottomDiv.removeEventListener('scroll', handleBottomScroll);
            }
        };
    }, []);
    useEffect(() => {
        addRow();
        addQuotation()
        fetchData()
    }, []);
    const fetchData = async () => {
        try {
            let param = `?DocType=Qutation`;
            if (CompareData?.compare === true) {
                let docParam = `?TypeOfDoc=PC&DocId=Price Comparison`
                const docRes = await apiService.getApiParamater("GET_DOC_ID", docParam);
                const params = new URLSearchParams();
                params.append('DocNo', '');
                params.append('DocumentType', "Price Comparison");
                const approvalList = await apiService.getApiParamater('GET_DOC_STATUS_EDIT', `?${params.toString()}`);
                setUser(approvalList?.data.result)
                setQuotationNo(docRes?.data.result[0].docId)
            } else {
                let docParam = `?TypeOfDoc=QT&DocId=Qutation`
                const docRes = await apiService.getApiParamater("GET_DOC_ID", docParam);
                const params = new URLSearchParams();
                params.append('DocNo', '');
                params.append('DocumentType', "Qutation");
                const approvalList = await apiService.getApiParamater('GET_DOC_STATUS_EDIT', `?${params.toString()}`);
                setUser(approvalList?.data.result)
                if (CompareData?.qotRecordId) {
                    setQuotationNo(CompareData?.qotRecordId)
                } else {
                    setQuotationNo(docRes?.data.result[0].docId)
                }
            }

            const response = await apiService.get('GET_SUPPLIER');
            setSupplier(response?.data?.result);
            const payResponse = await apiService.get('GET_EPAYMENT');
            setPayments([{ value: null, description: 'None' }, ...payResponse?.data?.result]);
        } catch (error) {
            console.error("Error fetching Currency data:", error);
        }
    };
    const GenerateNumber = async () => {
        if (CompareData?.compare === true) {
            let docParam = `?TypeOfDoc=PC&DocId=Price Comparison`
            const docRes = await apiService.getApiParamater("GET_DOC_ID", docParam);
            setQuotationNo(docRes?.data.result[0].docId)
            onCloseModal()
        } else {
            let docParam = `?TypeOfDoc=QT&DocId=Qutation`
            const docRes = await apiService.getApiParamater("GET_DOC_ID", docParam);
            setQuotationNo(docRes?.data.result[0].docId)
            onCloseModal()
        }
    }
    useEffect(() => {
        let isMounted = true;

        const fetchData = async () => {
            debugger;

            try {
                // =====================================================
                // CASE 1: EXISTING COMPARISON / QUOTATION
                // =====================================================
                if (CompareData?.qotRecordId) {
                    setLoader(true);

                    const response = await apiService.get("GET_QUOTATION");

                    if (!isMounted) return;

                    const data = response?.data?.result?.find(
                        item => item.requisitionNo === CompareData.requisitionNo
                    );

                    if (!data) {
                        console.warn(
                            "Quotation data not found for requisition:",
                            CompareData.requisitionNo
                        );
                        return;
                    }

                    setQuotationData(data);

                    // =====================================================
                    // TRANSFORM ROWS
                    // =====================================================
                    const transformedRows = (data.tempQuotationDetails || []).map(item => {
                        const quotations = [];

                        for (let i = 1; i <= 6; i++) {
                            const supplier = (item[`supp${i}`] || "").trim();

                            // Skip empty supplier columns
                            if (!supplier || supplier === "string") {
                                continue;
                            }

                            const unitPrice = Number(item[`price${i}`] || 0);
                            const qty = Number(item.qty || 0);

                            quotations.push({
                                supplierIndex: i,

                                itemCode: item.itemCode,
                                qty: qty,

                                selected: item[`selected${i}`] || 0,

                                unitPrice: unitPrice,
                                amount: unitPrice * qty,

                                supplier: supplier,
                                supplierId: item[`suppId${i}`] || "",

                                paymentTerms: item[`paymentTerms${i}`] || "",
                                refNo: item[`ref${i}`] || "",
                                remarks: item[`remarks${i}`] || ""
                            });
                        }

                        return {
                            srno: item.srno,

                            ItemNo: item.itemCode,

                            itemDescription: item.itemDescription,

                            Specs: item.specification || item.specs,

                            qty: Number(item.qty || 0),

                            uom: item.uom,

                            baseQty: Number(item.qty || 0),

                            baseAmount:
                                Number(item.qty || 0) *
                                Number(item.price1 || 0),

                            amount:
                                Number(item.qty || 0) *
                                Number(item.price1 || 0),

                            Delivery: "",

                            bol: "",

                            quotations: quotations
                        };
                    });

                    // =====================================================
                    // FORM DATA
                    // =====================================================
                    const transformedFormData = {
                        QuoteNo: data.quoteNo,

                        RequisitionNo: data.requisitionNo,

                        remarks: "",

                        costCenter1: data?.costCenter1,
                        costCenter2: data?.costCenter2,
                        costCenter3: data?.costCenter3,
                        costCenter4: data?.costCenter4,

                        quotation: []
                    };

                    // =====================================================
                    // SUPPLIER LIST
                    // =====================================================
                    const firstRow = transformedRows[0];

                    const quotations = firstRow?.quotations || [];

                    transformedFormData.quotation = quotations.map(quote => ({
                        ...quote
                    }));

                    // =====================================================
                    // SET STATE
                    // =====================================================
                    if (!isMounted) return;

                    setFormData(transformedFormData);
                    setRows(transformedRows);

                    // =====================================================
                    // FETCH ATTACHMENTS
                    // =====================================================
                    const attachparam =
                        `?DocNo=${CompareData.qotRecordId}&DocType=Qutation`;

                    const AttachmentResponse =
                        await apiService.getApiParamater(
                            "GET_ATTACHMENT",
                            attachparam
                        );

                    if (!isMounted) return;

                    const existingAttachments =
                        AttachmentResponse?.data?.result || [];

                    if (existingAttachments.length > 0) {
                        setAttachments(
                            mapAttachmentsFromApi(existingAttachments)
                        );
                    } else {
                        setAttachments([]);
                    }

                    return;
                }

                // =====================================================
                // CASE 2: NEW COMPARISON / PR DETAILS
                // =====================================================
                if (CompareData?.prDetails?.length) {
                    setLoader(true);

                    const params = new URLSearchParams();

                    params.append(
                        "DocNo",
                        CompareData?.requisitionNo
                    );

                    params.append(
                        "Action",
                        "CheckQtyForPCFromPOByRequisitionNo"
                    );

                    const res = await apiService.getApiParamater(
                        "GET_REQ_COMMON",
                        `?${params.toString()}`
                    );

                    if (!isMounted) return;

                    // API data can be array or single object
                    let apiItems = res?.data?.result?.data || [];

                    if (!Array.isArray(apiItems)) {
                        apiItems = apiItems ? [apiItems] : [];
                    }

                    // =====================================================
                    // NORMALIZE VALUES
                    // =====================================================
                    const normalize = (value) =>
                        value === null || value === undefined
                            ? ""
                            : String(value).trim().toLowerCase();

                    // =====================================================
                    // ONLY BIND PR DETAILS WHICH EXIST IN API RESPONSE
                    // =====================================================
                    const formattedRows = CompareData.prDetails
                        .filter((detail) => {
                            const matchingApiItem = apiItems.find((apiItem) => {
                                return (
                                    normalize(apiItem.ItemCode) ===
                                    normalize(detail.itemCode) &&

                                    normalize(apiItem.ItemDescription) ===
                                    normalize(detail.itemDescription) &&

                                    normalize(apiItem.Specification) ===
                                    normalize(detail.specification)
                                );
                            });

                            return !!matchingApiItem;
                        })
                        .map((detail) => ({
                            srno: detail.srno,

                            ItemNo: detail.itemCode,

                            recordId: detail.itemCode,

                            comparisonStatus:
                                CompareData.comparisonStatus,

                            itemDescription: detail.itemDescription,

                            Specs: detail.specification,

                            qty: detail.qty,

                            uom: detail.uom,

                            baseQty: detail.baseQty,

                            baseAmount: detail.baseAmount,

                            amount: detail.amount,

                            deliveryDate: detail.deliveryDate,

                            bol: "",

                            quotations: [
                                {
                                    itemCode: detail.itemCode,
                                    qty: detail.qty,
                                    unitPrice: 0,
                                    amount: "",
                                    supplier: "",
                                    paymentTerms: ""
                                },
                                {
                                    itemCode: detail.itemCode,
                                    qty: detail.qty,
                                    unitPrice: 0,
                                    amount: "",
                                    supplier: "",
                                    paymentTerms: ""
                                },
                                {
                                    itemCode: detail.itemCode,
                                    qty: detail.qty,
                                    unitPrice: 0,
                                    amount: "",
                                    supplier: "",
                                    paymentTerms: ""
                                }
                            ]
                        }));

                    if (!isMounted) return;

                    setRows(formattedRows);

                    return;
                }

                // =====================================================
                // CASE 3: INITIAL / EMPTY FORM
                // =====================================================
                if (!CompareData) {
                    const initialFormData = {
                        recordId: CompareData?.requisitionNo,

                        QuoteNo: "",

                        remarks: CompareData?.remarks,

                        costCenter1: CompareData?.costCenter1,
                        costCenter2: CompareData?.costCenter2,
                        costCenter3: CompareData?.costCenter3,
                        costCenter4: CompareData?.costCenter4,

                        quotation: [
                            {
                                refNo: 0,
                                paymentTerms: [],
                                supplier: [],
                                remarks: ""
                            },
                            {
                                refNo: 0,
                                paymentTerms: [],
                                supplier: [],
                                remarks: ""
                            },
                            {
                                refNo: 0,
                                paymentTerms: [],
                                supplier: [],
                                remarks: ""
                            }
                        ]
                    };

                    if (!isMounted) return;

                    setFormData(initialFormData);
                    setQuotationData(null);
                    setRows([]);
                    setAttachments([]);
                }

            } catch (error) {
                console.error(
                    "Error fetching comparison data:",
                    error
                );

                if (isMounted) {
                    setRows([]);
                }

            } finally {
                if (isMounted) {
                    setLoader(false);
                }
            }
        };

        // =====================================================
        // COMMON STATE VALUES
        // =====================================================
        setRequisitionNo(
            CompareData?.requisitionNo
        );

        setQuotationNo(
            CompareData?.qotRecordId ||
            compare?.qotRecordId
        );

        dispatch(setComparison(CompareData));

        // =====================================================
        // FETCH DATA
        // =====================================================
        fetchData();

        // =====================================================
        // CLEANUP
        // =====================================================
        return () => {
            isMounted = false;
        };

    }, [CompareData, compare]);

    const mapAttachmentsFromApi = (apiData) => {
        const validFiles = apiData.filter(
            a => a.fileName && a.fileName.trim() !== ""
        );

        return [
            ...validFiles.map(item => ({
                id: Date.now() + Math.random(), // UI id
                dbId: item.rcno,                // backend id
                file: null,                     // existing file (no File object)
                fileName: item.fileName,
                remarks: item.remarks || "",
                isNew: false,
                isDeleted: false,
            })),
            createEmptyRow()
        ];
    };
    const handleCheckboxChange = (rowIndex, quotationIndex, checked) => {
        const updatedRows = [...rows];
        updatedRows[rowIndex].quotations.forEach((quotation, index) => {
            quotation.selected = 0;
        });
        if (checked) {
            updatedRows[rowIndex].quotations[quotationIndex].selected = 1;
        }
        setRows(updatedRows);
    };
    const handleTableChange = (rowIndex, quotationIndex, field, value) => {
        if (value < 0) {
            return;
        }
        setRows(prevRows => {
            const updatedRows = [...prevRows];
            const updatedQuotations = [...updatedRows[rowIndex].quotations];
            updatedQuotations[quotationIndex] = {
                ...updatedQuotations[quotationIndex],
                [field]: value
            };

            if (field === 'unitPrice') {
                const qty = updatedQuotations[quotationIndex].qty;
                updatedQuotations[quotationIndex].amount = value * qty;
            }

            updatedRows[rowIndex] = {
                ...updatedRows[rowIndex],
                quotations: updatedQuotations
            };

            return updatedRows;
        });
    };
    const addQuotation = () => {
        const updatedRows = rows?.map(row => ({
            ...row,
            quotations: [
                ...row.quotations,
                {
                    qty: "",
                    unitPrice: 0,
                    amount: "",
                    supplier: "",
                    paymentTerms: ""
                },
            ]
        }));
        setRows(updatedRows);
    };
    const addRow = () => {
        const newRow = {
            srno: '',
            ItemNo: '',
            itemDescription: '',
            Specs: '',
            qty: '',
            uom: '',
            baseQty: '',
            baseAmount: '',
            amount: '',
            Delivery: '',
            bol: '',
            quotations: initialQuotations,
        };
        const newRows = [...rows, newRow];
        setRows(newRows);
    };
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    };
    const handleQuotationChange = (index, e) => {
        const { id, value } = e.target;
        setFormData(prevFormData => {
            const updatedQuotations = [...prevFormData.quotation];
            updatedQuotations[index] = {
                ...updatedQuotations[index],
                [id.replace(/\d+/, '')]: value
            };
            return { ...prevFormData, quotation: updatedQuotations };
        });

        setRows(prevRows => {
            const updatedRows = [...prevRows];
            updatedRows.forEach(row => {
                if (row.quotations[index]) {
                    row.quotations[index][id.replace(/\d+/, '')] = value;
                }
            });
            return updatedRows;
        });
    };
    const handleSupChange = (selectedOption, index) => {
        const selectedSupplier = selectedOption.value;
        const supplierData = suppliers.find(sup => sup.supplierName === selectedSupplier);
        const defaultPaymentTerm = payments.find(pay => pay.description === supplierData?.paymentTerm);
        const supplierAlreadySelected = formData.quotation.some(quotation => quotation.supplier === selectedOption.label);
        // if (supplierAlreadySelected) {
        //     toast.warning('Supplier already selected');
        //     return;
        // }

        setFormData(prevFormData => {
            const updatedQuotations = [...prevFormData.quotation];
            updatedQuotations[index] = {
                ...updatedQuotations[index],
                supplier: selectedOption?.label,
                supplierId: supplierData?.supplier_ID,
                paymentTerms: defaultPaymentTerm?.description || null
            };
            return { ...prevFormData, quotation: updatedQuotations };
        });
        setRows(prevRows => {
            const updatedRows = [...prevRows];
            updatedRows.forEach(row => {
                if (row.quotations[index]) {
                    row.quotations[index].supplier = selectedOption?.label;
                    row.quotations[index].supplierId = supplierData?.supplier_ID;
                    row.quotations[index].paymentTerms = defaultPaymentTerm?.description || null;
                }
            });

            return updatedRows;
        });
    };
    const handleAddRow = () => {
        setFormData(prevFormData => ({
            ...prevFormData,
            quotation: [...prevFormData.quotation, { refNo: '', payment: '', supplier: '', remarks: '' }],
        }));

        setRows(prevRows => prevRows.map(row => ({
            ...row,
            quotations: [...row.quotations, {
                itemCode: row.itemCode,
                qty: row.qty,
                unitPrice: 0,
                amount: "",
                supplier: "",
                paymentTerms: ""
            }]
        })));
    };
    const handleDeleteQuotation = (index) => {
        setFormData(prevFormData => {
            const updatedQuotations = prevFormData.quotation.filter((_, i) => i !== index);
            return { ...prevFormData, quotation: updatedQuotations };
        });

        setRows(prevRows => prevRows.map(row => ({
            ...row,
            quotations: row.quotations.filter((_, i) => i !== index)
        })));
    };
    const handlePaymentTermChange = (selectedOption, index) => {
        setFormData(prevFormData => {
            const updatedQuotations = [...prevFormData.quotation];
            updatedQuotations[index] = {
                ...updatedQuotations[index],
                paymentTerms: selectedOption?.label
            };
            return { ...prevFormData, quotation: updatedQuotations };
        });

        setRows(prevRows => {
            const updatedRows = [...prevRows];
            updatedRows.forEach(row => {
                if (row.quotations[index]) {
                    row.quotations[index].paymentTerms = selectedOption?.label;
                }
            });
            return updatedRows;
        });

    };
    const CreateQuotation = async () => {
        try {
            setLoader(true)
            const maxQuotations = 6;
            let validSuppliers = 0;
            for (const supplier of formData.quotation) {
                if (supplier.supplier) {
                    validSuppliers++;
                }
            }
            if (validSuppliers < 2) {
                toast.warning(`Please add at least 2 valid suppliers before creating the quotation.`);
                setLoader(false)
                return;
            }

            const itemDetails = rows?.map((item, index) => {
                const itembody = {
                    srno: item.srno || index + 1,
                    itemCode: item.ItemNo,
                    itemDescription: item.itemDescription,
                    uom: item.uom,
                    qty: item.qty,
                };

                for (const items of item?.quotations) {
                    if (!items.supplier) {
                        continue;
                    }
                    if (!items.unitPrice || parseFloat(items.unitPrice) <= 0) {
                        toast.warning(`${item.itemDescription || 'Item'}: Unit Price must be greater than 0.`);
                        setLoader(false);
                        return;
                    }
                }
                for (const items of item?.quotations) {
                    if (!items.supplier && items.unitPrice) {
                        toast.warning(`${item.itemDescription || 'Item'}: Supplier must be Selected.`);
                        setLoader(false);
                        return;
                    }
                }
                item?.quotations.forEach((quotation, index) => {
                    if (index >= maxQuotations) {
                        toast.error(`Quotation limit exceeded for item ${item.ItemNo}. Maximum allowed is ${maxQuotations}.`);
                        setLoader(false)
                        return;
                    }
                    const suffix = index + 1;
                    itembody[`supp${suffix}`] = quotation.supplier || "";
                    itembody[`ref${suffix}`] = quotation?.refNo || "";
                    itembody[`remarks${suffix}`] = quotation?.remarks || "";
                    itembody[`paymentTerms${suffix}`] = quotation.paymentTerms || "";
                    itembody[`price${suffix}`] = quotation.unitPrice ? parseFloat(quotation.unitPrice) : 0;
                    itembody[`selected${suffix}`] = 0;
                    itembody[`suppId${suffix}`] = quotation.supplierId;
                });
                for (let i = item.quotations.length + 1; i <= maxQuotations; i++) {
                    itembody[`supp${i}`] = "";
                    itembody[`ref${i}`] = "";
                    itembody[`remarks${i}`] = "";
                    itembody[`paymentTerms${i}`] = "";
                    itembody[`price${i}`] = 0;
                    itembody[`selected${i}`] = 0;
                    itembody[`suppId${i}`] = "";
                }
                return itembody;
            });
            const requestBody = {
                quoteDate: new Date().toISOString(),
                quoteNo: QuotationNo,
                requisitionNo: RequisitionNo,
                status: 0,
                isActive: true,
                costCenter1: CompareData?.costCenter1,
                costCenter2: CompareData?.costCenter2,
                costCenter3: CompareData?.costCenter3,
                costCenter4: CompareData?.costCenter4,
                modifiedBy: userName,
                isEditable: 0,
                tempQuotationDetails: itemDetails
            };

            const response = await apiService.post("CREATE_QUOTATION", requestBody);
            if (response?.data?.statusCode === 201) {
                const userData2 = {
                    docType: "Quotation",
                    docId: QuotationNo,
                    department: "IT",
                    company: Company?.selectedCompany?.companyNo,
                    userCode: userId,
                    userName: userName,
                }
                const docBody = {
                    docId: "Qutation",
                    typeOfDoc: "QT",
                };
                const docRes = await apiService.put("UPDATE_DOC_ID", docBody);
                if (attachments) {
                    let name = "Qutation"
                    let no = QuotationNo
                    handleUpload(name, no)
                }
                const response2 = await apiService.post("CREATE_DOC_AUTHORIZATION", userData2);
                const paramsGet = new URLSearchParams();
                paramsGet.append('docType', "Qutation");
                paramsGet.append('docId', QuotationNo);
                paramsGet.append('srno', 1);
                const response3 = await apiService.getApiParamater('GET_DOC_APPROVAL_USER', `?${paramsGet.toString()}`);
                // if (response3?.data?.result.length > 0) {
                //     const toEmails = response3?.data?.result?.map(user => user.userEmail);
                //     const emailbody = {
                //         toEmails: toEmails,
                //         subject: "Qutation",
                //         body: "",
                //         docNo: QuotationNo,
                //         srNo: 1,
                //         docType: "Qutation"
                //     };
                //     const emailres = await apiService.post("DOC_APPROVAL_EMAIL_POST", emailbody);
                // }
                dispatch(clearComparison());
                toast.success(` ${QuotationNo} Created successfully`);
                navigate("/inventory/PriceComparison/List");
                setLoader(false)
            } else if (response?.data?.statusCode === 208) {
                setLoader(false)
                onOpenModal()
            }
        } catch (error) {
            setLoader(false)
            console.error("Error Creating Quotation:", error);
        }
    };
    const UpdateQuotation = async () => {
        try {
            setLoader(true)
            const maxQuotations = 6;
            let validSuppliers = 0;
            for (const supplier of formData.quotation) {
                if (supplier.supplier) {
                    validSuppliers++;
                }
            }
            if (validSuppliers < 2) {
                toast.warning(`Please add at least 2 valid suppliers before creating the quotation.`);
                setLoader(false)
                return;
            }
            const itemDetails = rows?.map((item, index) => {
                const itembody = {
                    srno: item.srno || index + 1,
                    itemCode: item.ItemNo,
                    itemDescription: item.itemDescription,
                    uom: item.uom,
                    qty: item.qty,
                }

                for (const items of item?.quotations) {
                    if (!items.supplier) {
                        continue;
                    }
                    // if (!items.unitPrice || parseFloat(items.unitPrice) <= 0) {
                    //     toast.warning(`${item.itemDescription || 'Item'}: Unit Price must be greater than 0.`);
                    //     setLoader(false);
                    //     return;
                    // }
                }
                for (const items of item?.quotations) {
                    if (!items.supplier && items.unitPrice) {
                        toast.warning(`${item.itemDescription || 'Item'}: Supplier must be Selected.`);
                        setLoader(false);
                        return;
                    }
                }
                item?.quotations.forEach((quotation, index) => {
                    if (index >= maxQuotations) {
                        toast.error(`Quotation limit exceeded for item ${item.ItemNo}. Maximum allowed is ${maxQuotations}.`);
                        setLoader(false)
                        return;
                    }
                    const suffix = index + 1;
                    itembody[`supp${suffix}`] = quotation.supplier;
                    itembody[`ref${suffix}`] = quotation?.refNo;
                    itembody[`remarks${suffix}`] = quotation?.remarks;
                    itembody[`paymentTerms${suffix}`] = quotation.paymentTerms;
                    itembody[`price${suffix}`] = quotation.unitPrice ? parseFloat(quotation.unitPrice) : 0;
                    itembody[`selected${suffix}`] = 0;
                    itembody[`suppId${suffix}`] = quotation.supplierId;
                });
                for (let i = item.quotations.length + 1; i <= maxQuotations; i++) {
                    itembody[`supp${i}`] = "";
                    itembody[`ref${i}`] = "";
                    itembody[`remarks${i}`] = "";
                    itembody[`paymentTerms${i}`] = "";
                    itembody[`price${i}`] = 0;
                    itembody[`selected${i}`] = 0;
                    itembody[`suppId${i}`] = "";
                }
                return itembody;
            });
            const requestBody = {
                quoteDate: new Date().toISOString(),
                requisitionNo: RequisitionNo,
                quoteNo: quotationData.quoteNo,
                modifiedBy: userName,
                status: 0,
                isActive: true,
                costCenter1: CompareData?.costCenter1,
                costCenter2: CompareData?.costCenter2,
                costCenter3: CompareData?.costCenter3,
                costCenter4: CompareData?.costCenter4,
                tempQuotationDetails: itemDetails
            };
            const response = await apiService.put("UPDATE_QUOTATION", requestBody);

            if (response?.data?.statusCode === 201) {
                const userData2 = {
                    docType: "Qutation",
                    docId: QuotationNo,
                    status: 0,
                };
                if (attachments) {
                    let name = "Qutation"
                    let docNo = QuotationNo
                    handleUpdate(name, docNo)
                }
                const response2 = await apiService.put("UPDATE_DOC_AUTHORIZATION_STATUS", userData2);
                const paramsGet = new URLSearchParams();
                paramsGet.append('docType', "Quotation");
                paramsGet.append('docId', QuotationNo);
                paramsGet.append('srno', 1);
                const response3 = await apiService.getApiParamater('GET_DOC_APPROVAL_USER', `?${paramsGet.toString()}`);
                // if (response3?.data?.result.length > 0) {
                //     const toEmails = response3?.data?.result?.map(user => user.userEmail);
                //     const emailbody = {
                //         toEmails: toEmails,
                //         subject: "Qutation",
                //         body: "",
                //         docNo: QuotationNo,
                //         srNo: 1,
                //         docType: "Qutation"
                //     };
                //     const emailres = await apiService.post("DOC_APPROVAL_EMAIL_POST", emailbody);
                // }
                navigate("/inventory/PriceComparison/List");
                setLoader(false)
                dispatch(clearComparison());
            }
        } catch (error) {
            setLoader(false)
            console.error("Error Creating Qutation:", error);
        }
    };
    const CreateComaprison = async () => {
        try {
            setLoader(true)
            const currentDatetimeUTC = new Date().toISOString();
            const maxQuotations = 6;
            if (formData.quotation[0].supplier.length === 0) {
                toast.error("Please select suppliers before creating the quotation.");
                setLoader(false)
                return;
            }

            const hasSelectedQuotation = rows.every(item =>
                item.quotations.some(quotation => quotation.selected === 1)
            );

            if (!hasSelectedQuotation) {
                toast.error("Each item must have at least one selected quotation.");
                setLoader(false);
                return;
            }
            const itemDetails = rows?.map((item, index) => {
                const itembody = {
                    srno: item.srno || index + 1,
                    itemCode: item.ItemNo,
                    itemDescription: item.itemDescription,
                    uom: item.uom,
                    qty: item.qty,
                }
                item?.quotations.forEach((quotation, index) => {
                    if (index >= maxQuotations) {
                        toast.error(`Quotation limit exceeded for item ${item.ItemNo}. Maximum allowed is ${maxQuotations}.`);
                        setLoader(false)
                        return;
                    }

                    const suffix = index + 1;
                    itembody[`supp${suffix}`] = quotation.supplier;
                    itembody[`ref${suffix}`] = quotation?.refNo;
                    itembody[`remarks${suffix}`] = quotation?.remarks;
                    itembody[`paymentTerms${suffix}`] = quotation.paymentTerms;
                    itembody[`price${suffix}`] = quotation.unitPrice;
                    itembody[`selected${suffix}`] = quotation.selected;
                    itembody[`suppId${suffix}`] = quotation.supplierId;
                });
                for (let i = item.quotations.length + 1; i <= maxQuotations; i++) {
                    itembody[`supp${i}`] = "";
                    itembody[`ref${i}`] = "";
                    itembody[`remarks${i}`] = "";
                    itembody[`paymentTerms${i}`] = "";
                    itembody[`price${i}`] = 0;
                    itembody[`selected${i}`] = 0;
                    itembody[`suppId${i}`] = "";
                }
                return itembody;
            });
            const calculateTotalPrice = (itemDetails) => {
                let totalAmount = 0;
                itemDetails.forEach(item => {
                    for (let i = 1; i <= 6; i++) {
                        if (item[`selected${i}`] === 1) {
                            totalAmount += item[`price${i}`] * item.qty;
                        }
                    }
                });
                return totalAmount;
            };
            const totalAmount = calculateTotalPrice(itemDetails);
            const requestBody = {
                pcDate: new Date().toISOString(),
                pcNo: QuotationNo,
                requisitionNo: RequisitionNo,
                quoteNo: CompareData?.qotRecordId,
                status: 0,
                isActive: true,
                isEditable: 1,
                modifiedBy: userName,
                amount: totalAmount,
                costCenter1: CompareData?.costCenter1,
                costCenter2: CompareData?.costCenter2,
                costCenter3: CompareData?.costCenter3,
                costCenter4: CompareData?.costCenter4,
                priceComparisonDetails: itemDetails
            };
            const response = await apiService.post("CREATE_PC", requestBody);
            if (response?.data?.statusCode === 201) {
                const userData2 = {
                    docId: QuotationNo,
                    department: "IT",
                    docType: "Price Comparison",
                    company: Company?.selectedCompany?.companyNo,
                    userCode: userId,
                    userName: userName,
                };
                const docBody = {
                    docId: "Price Comparison",
                    typeOfDoc: "PC"
                }
                const docRes = await apiService.put("UPDATE_DOC_ID", docBody);
                if (attachments) {
                    let name = "Qutation"
                    let no = CompareData?.qotRecordId
                    handleUpload(name, no)
                }
                const response2 = await apiService.post("CREATE_DOC_AUTHORIZATION", userData2);
                const paramsGet = new URLSearchParams()
                paramsGet.append('docType', "Price Comparison")
                paramsGet.append('docId', QuotationNo)
                paramsGet.append('srno', 1)
                const response3 = await apiService.getApiParamater('GET_DOC_APPROVAL_USER', `?${paramsGet.toString()}`);
                // if (response3?.data?.result.length > 0) {
                //     const toEmails = response3?.data?.result?.map(user => user.userEmail);
                //     const emailbody = {
                //         toEmails: toEmails,
                //         subject: "Price Comparison",
                //         body: "",
                //         docNo: QuotationNo,
                //         srNo: 1,
                //         docType: "Price Comparison"
                //     };
                //     const emailres = await apiService.post("DOC_APPROVAL_EMAIL_POST", emailbody);
                // }
                toast.success(` ${QuotationNo} Created successfully`);
                dispatch(clearComparison())
                setLoader(false)
                navigate("/inventory/PriceComparison/List");
            } else if (response?.data?.statusCode === 208) {
                setLoader(false)
                onOpenModal()
            }
        } catch (error) {
            setLoader(false)
            console.error("Error Creating Quotation:", error);
        }
    };
    const calculateSubtotals = () => {
        const totals = {};
        rows.forEach(row => {
            row.quotations.forEach(quotation => {
                if (quotation.selected === 1) {
                    if (!totals[quotation.supplier]) {
                        totals[quotation.supplier] = 0;
                    }
                    totals[quotation.supplier] += quotation.amount;
                }
            });
        });
        setSuppliersTotals(totals);
    };
    useEffect(() => {
        calculateSubtotals();
    }, [rows]);
    const supplierTotals = {};
    const staticSupplier = [];

    rows?.forEach(row => {
        row.quotations.forEach((quotation, quotationIndex) => {
            const supplierName = quotation.supplier;

            // Supplier exists
            if (supplierName) {
                const supplierKey = `${supplierName}_${quotationIndex + 1}`;

                if (!supplierTotals[supplierKey]) {
                    supplierTotals[supplierKey] = {
                        supplier: supplierName,
                        index: quotationIndex + 1,
                        qty: 0,
                        amount: 0
                    };
                }

                supplierTotals[supplierKey].qty += Number(quotation.qty || 0);
                supplierTotals[supplierKey].amount += Number(quotation.amount || 0);
            }
            // No supplier
            else {
                staticSupplier.push({
                    index: quotationIndex + 1,
                    qty: Number(quotation.qty || 0),
                    amount: Number(quotation.amount || 0)
                });
            }
        });
    });

    // Add static supplier separately
    if (staticSupplier.length > 0) {
        supplierTotals.staticSupplier = {
            supplier: "staticSupplier",
            index: null,
            qty: staticSupplier.reduce(
                (total, item) => total + item.qty,
                0
            ),
            amount: staticSupplier.reduce(
                (total, item) => total + item.amount,
                0
            )
        };
    }
    const handleBackClick = () => {
        window.history.back();
    };
    const preventNegativeSign = (e) => {
        if (e.key === "-" || e.key === "+") {
            e.preventDefault();
        }
    };

    // Attachment Functions
    const handleUpload = async (name, no) => {
        const formData = new FormData();

        attachments.forEach(({ file }) => {
            if (file instanceof File) {
                formData.append("Images", file, file.name);
            }
        });

        const response = await apiService.postMultiPart(
            "UPLOAD_FILE",
            formData
        );

        if (response?.data?.statusCode === 201 && response?.data?.isSuccessful) {
            const uploadedFileNames = response.data.result.split(",");

            const payload = {
                docFilesDtos: attachments
                    .filter((a) => a.file)
                    .map((a, index) => ({
                        srno: index + 1,
                        docNo: no,
                        docType: name,
                        fileName: uploadedFileNames[index]?.trim(),
                        remarks: a.remarks || "",
                    })),
            };

            await apiService.post("CREATE_ATTACHMENT", payload);
            return
        }
    };
    const handleUpdate = async (name, docNo) => {
        const formData = new FormData();
        attachments.forEach(({ file }) => {
            if (file instanceof File) {
                formData.append("Images", file, file.name);
            }
        });

        const response = await apiService.postMultiPart(
            "UPLOAD_FILE",
            formData
        );

        if (response?.data?.statusCode === 201 && response?.data?.isSuccessful) {

            const uploadedFileNames = response.data.result.split(",");
            let uploadedIndex = 0;

            const payload = {
                docFilesDtos: attachments
                    .filter(a => {
                        //  skip deleted
                        if (a.isDeleted === true) return false;

                        //  keep old files
                        if (a.fileName && a.fileName.trim()) return true;

                        //  keep new uploads only if file exists
                        if (a.isNew && a.file) return true;

                        //  skip empty rows
                        return false;
                    })
                    .map((a, index) => {

                        let fileName = a.fileName?.trim();

                        // 🔁 Assign uploaded filename ONLY to new attachments
                        if (!fileName && a.isNew) {
                            fileName = uploadedFileNames[uploadedIndex]?.trim();
                            uploadedIndex++;
                        }
                        return {
                            rcno: a?.dbId,
                            srno: index + 1,
                            docNo: docNo,
                            docType: name,
                            fileName,
                            remarks: a.remarks || "",
                        };
                    }),
                docNo: docNo,
            };

            await apiService.put("UPDATE_ATTACHMENT", payload);
        }

    };
    const handleFileSelect = (file, id) => {
        setAttachments(prev => {
            const updated = prev.map(row =>
                row.id === id
                    ? {
                        ...row,
                        file,
                        fileName: file.name,
                        isNew: true
                    }
                    : row
            );

            return [...updated, createEmptyRow()];
        });
    };
    const handleRemarkChange = (id, value) => {
        setAttachments(prev =>
            prev.map(row =>
                row.id === id ? { ...row, remarks: value } : row
            )
        );
    };
    const handleDelete = (id) => {
        setAttachments(prev =>
            prev.map(row =>
                row.id === id
                    ? { ...row, isDeleted: true }
                    : row
            )
        );
    }
    const handleView = (file) => {
        if (!file) return;
        if (file?.isNew === false) {
            setPreviewImage(file?.fileName);
        } else {
            setPreviewImage(URL.createObjectURL(file?.file));
        }
        setPreview(file)
        setPreviewModal(true);
    }
    const handleDeleteRow = (rowIndex) => {
        setRows(prevRows => prevRows.filter((_, index) => index !== rowIndex));
    };
    return (
        <div className='p-4'>
            <div>
                <div className='d-flex gap-3 end'>
                    <div className=''>
                        {CompareData?.found === true ?
                            <>{CompareData?.compare === true ?
                                <>{loader === true ?
                                    <button className='mainbtn'><ClipLoader size={25} color='#fff' /></button> :
                                    <button className='mainbtn' type="submit" onClick={CreateComaprison}>
                                        <FaSave className='center mt-1 mx-2' /><div>Save</div>
                                    </button>
                                }</> :
                                <>{loader === true ?
                                    <button className='mainbtn '><ClipLoader size={25} color='#fff' /></button> :
                                    <button className='mainbtn ' type="submit" onClick={UpdateQuotation}>
                                        <RiRefreshLine className='center mt-1 mx-2' /><div>Update</div>
                                    </button>
                                }</>
                            }</>
                            :
                            <>{CompareData?.compare === true ? " " :
                                <>{loader === true ?
                                    <button className='mainbtn '><ClipLoader size={25} color='#fff' /></button> :
                                    <button className='mainbtn ' type="submit" onClick={CreateQuotation}>
                                        <FaSave className='center mt-1 mx-2' /><div>Save</div>
                                    </button>
                                }</>
                            }</>}
                    </div>
                    <div className=''>
                        <button onClick={handleBackClick} className='mainbtnSecondary'>
                            <FaAngleLeft className='center mt-1 mx-2' /><div>Back</div>
                        </button>
                    </div>
                </div>
                <div className="cost-center-section mb-2">
                    <div className="d-flex mt-3 cursor-pointer slide-header gap-4"
                        onClick={() => setSupplierTab(!SupplierTab)}>
                        <div className='h6 pt-1'>Comparison Details</div>
                    </div>
                    <div className={`slide-content ${SupplierTab ? 'open' : 'closed'}`}>
                        <div className="border-box2 p-3">
                            <div className='row'>
                                <div className='col-5'>
                                    <div className=" d-flex justify-content-between">
                                        <label htmlFor="QuoteNo" className="form-label  pt-2 start">Quote No</label>
                                        <input
                                            className="form-Input w-100"
                                            value={QuotationNo ? `${QuotationNo}` : " "}
                                            disabled
                                        />
                                    </div>
                                    <div className="py-2 d-flex justify-content-between">
                                        <label htmlFor="RequisitionNo" className="form-label  pt-2 start">Requisition No</label>
                                        <input className="form-Input w-100" disabled value={RequisitionNo} />
                                    </div>
                                    <div className=" d-flex justify-content-between">
                                        <label htmlFor="PropertyGroup" className="form-label  pt-2 start">Property</label>
                                        <input className="form-Input w-100" disabled value={CompareData?.costCenter1 || formData?.costCenter1} />
                                    </div>
                                    <div className="py-2 d-flex justify-content-between">
                                        <label htmlFor="Property" className="form-label  pt-2 start">Unit</label>
                                        <input className="form-Input w-100" disabled value={CompareData?.costCenter2 || formData?.costCenter2} />
                                    </div>
                                    <div className=" d-flex justify-content-between">
                                        <label htmlFor="Department" className="form-label  pt-2 start">Cost Center 3</label>
                                        <input className="form-Input w-100" disabled value={CompareData?.costCenter3 || formData?.costCenter3} />
                                    </div>
                                    <div className="pt-2 d-flex justify-content-between">
                                        <label htmlFor="Outlet" className="form-label  pt-2 start">Cost Center 4</label>
                                        <input className="form-Input w-100" disabled value={CompareData?.costCenter4 || formData?.costCenter4} />
                                    </div>
                                </div>
                                <div className='col-7'>
                                    <div className='d-flex gap-3'>
                                        <div className="brderbox px-3 center" onClick={() => openModal()} >
                                            {'Attachment'}
                                        </div>
                                        <div className="">
                                            <button className="mainbtn" onClick={handleAddRow}>Add More</button>
                                        </div>
                                    </div>
                                    <div className="d-flex mt-2 gap-2 ovrflo" ref={topDivRef} >
                                        {formData?.quotation?.map((quotation, index) => (
                                            <div key={index} className="col-md-4 col-lg-3 quotationbox py-3 px-2">
                                                <div className='d-flex justify-content-between pb-1'>
                                                    <label className="form-label">Supplier</label>
                                                    <RxCross2 onClick={() => handleDeleteQuotation(index)} />
                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <Select theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 5,
                                                        padding: 9
                                                    })}
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                            option: (provided, state) => ({
                                                                ...provided,
                                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                                color: state.isFocused ? '#000 ' : '#000',
                                                                ':hover': {
                                                                    backgroundColor: '#F5F5F5',
                                                                    color: '#000 ',
                                                                },
                                                            }),
                                                        }}
                                                        className="p-0 w-100 "
                                                        value={quotation?.supplier ? { value: quotation?.supplier, label: quotation?.supplier } : { label: "Select Supplier", value: "Select Supplier" }}
                                                        onChange={(selectedOption) => handleSupChange(selectedOption, index)}
                                                        options={suppliers?.map((sup) => ({ value: sup?.supplierName, label: sup?.supplierName }))}
                                                    />
                                                </div>
                                                <div className="my-2 d-flex justify-content-between">
                                                    <Select theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 5,
                                                        padding: 9
                                                    })}
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                            option: (provided, state) => ({
                                                                ...provided,
                                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                                color: state.isFocused ? '#000 ' : '#000',
                                                                ':hover': {
                                                                    backgroundColor: '#F5F5F5',
                                                                    color: '#000 ',
                                                                },
                                                            }),
                                                        }}
                                                        className="p-0 w-100 "
                                                        options={payments?.map((pay) => ({ value: pay?.description, label: pay?.description }))}
                                                        onChange={(selectedOption) => handlePaymentTermChange(selectedOption, index)}
                                                        value={quotation?.paymentTerms ? { value: quotation?.paymentTerms, label: quotation?.paymentTerms } : { label: "Select Payment Term", value: "Select Supplier" }}
                                                    />
                                                </div>
                                                <div className="d-flex justify-content-between">
                                                    <input
                                                        type="text" onWheel={(e) => e.target.blur()}
                                                        className="form-Input w-100 "
                                                        id={`refNo${index}`}
                                                        value={quotation.refNo}
                                                        onChange={(e) => handleQuotationChange(index, e)}
                                                        placeholder="Quotation Ref No"
                                                    />
                                                </div>
                                                <div className="d-flex justify-content-between mt-2">
                                                    <textarea
                                                        className="form-Input w-100 "
                                                        id={`remarks${index}`}
                                                        onChange={(e) => handleQuotationChange(index, e)}
                                                        placeholder="Remarks"
                                                        value={quotation.remarks}
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`cost-center-section`}>
                    <div className="mt-3 cursor-pointer slide-header">
                        <div className="nav nav-pills overslid d-flex gap-4">
                            {/* Nav tabs */}
                            <div
                                className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                                onClick={() => handleTabClick(0)}
                            >
                                Price Comparison
                            </div>
                            <div
                                className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                                onClick={() => handleTabClick(1)}
                            >
                                Authorization
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`slide-content open`}>
                    <div className={`grid-1 border-box2 p-3`}>
                        {gridVisibility[0] && (
                            <div className="grid-1">
                                <div className='table-container mb-1' ref={bottomDivRef} style={{ overflowX: 'auto', height: "auto" }}>
                                    <table>
                                        <thead className="dynoTable">
                                            {/* Supplier Header */}
                                            <tr>
                                                <th rowSpan="2"></th>
                                                <th rowSpan="2">Sr no</th>
                                                <th rowSpan="2">Item No</th>
                                                <th rowSpan="2">Description</th>
                                                <th rowSpan="2">Item Specs</th>
                                                <th rowSpan="2">UOM</th>
                                                <th rowSpan="2">Delivery Date</th>

                                                {rows?.[0]?.quotations?.map((q, index) => (
                                                    <th
                                                        key={index}
                                                        colSpan="4"
                                                        className="supplier-header"
                                                    >
                                                        {typeof q.supplier === "object"
                                                            ? q.supplier?.label
                                                            : q.supplier || `Supplier ${index + 1}`}
                                                    </th>
                                                ))}
                                            </tr>

                                            {/* Supplier Sub Headers */}
                                            <tr>
                                                {rows?.[0]?.quotations?.map((_, index) => (
                                                    <React.Fragment key={index}>
                                                        <th>Select</th>
                                                        <th>Qty</th>
                                                        <th>Unit Price</th>
                                                        <th>Amount</th>
                                                    </React.Fragment>
                                                ))}
                                            </tr>
                                        </thead>

                                        {!rows ? (
                                            <tbody>
                                                <tr>
                                                    <td colSpan={6 + ((rows?.[0]?.quotations?.length || 0) * 4)}>
                                                        <div className="text-center">
                                                            <ClipLoader size={50} color="#5B93FF" />
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        ) : (
                                            <tbody>
                                                {rows?.map((row, index) => (
                                                    <tr key={index}>
                                                        <td className="m-0 p-0 text-center">
                                                            <button
                                                                type="button"
                                                                title="Remove Item"
                                                                onClick={() => handleDeleteRow(index)}
                                                                // disabled={isReadOnly}
                                                                style={{
                                                                    border: "none",
                                                                    background: "transparent",
                                                                    color: "#dc3545",
                                                                    cursor: "pointer",
                                                                    fontSize: "22px",
                                                                    padding: "4px 8px"
                                                                }}
                                                            >
                                                                <RxCross2 />
                                                            </button>
                                                        </td>

                                                        {/* Static Columns */}
                                                        <td className="m-0 p-0">
                                                            <input
                                                                style={{ width: "100%" }}
                                                                className="p-1"
                                                                type="number"
                                                                disabled
                                                                value={index + 1}
                                                            />
                                                        </td>

                                                        <td className="m-0 p-0">
                                                            <input
                                                                style={{ width: "100%" }}
                                                                className="p-1"
                                                                type="text"
                                                                disabled
                                                                value={row.ItemNo || ""}
                                                            />
                                                        </td>

                                                        <td className="m-0 p-0">
                                                            <input
                                                                className="p-1"
                                                                type="text"
                                                                disabled
                                                                value={row.itemDescription || ""}
                                                            />
                                                        </td>

                                                        <td className="m-0 p-0">
                                                            <input
                                                                style={{ width: "100%" }}
                                                                className="p-1"
                                                                type="text"
                                                                disabled
                                                                value={row.Specs || ""}
                                                            />
                                                        </td>

                                                        <td className="m-0 p-0">
                                                            <input
                                                                style={{ width: "100%" }}
                                                                className="p-1"
                                                                type="text"
                                                                disabled
                                                                value={row.uom || ""}
                                                            />
                                                        </td>

                                                        <td className="m-0 p-0">
                                                            <input
                                                                style={{ width: "100%" }}
                                                                className="p-1"
                                                                disabled
                                                                value={moment(CompareData?.deliveryDate).format("L")}
                                                            />
                                                        </td>

                                                        {/* Supplier Columns */}
                                                        {rows?.[0]?.quotations?.map((headerQuotation, quotationIndex) => {

                                                            const q = row?.quotations?.[quotationIndex];

                                                            return (
                                                                <React.Fragment key={quotationIndex}>

                                                                    {/* Select */}
                                                                    <td>
                                                                        {q ? (
                                                                            <div className="center">
                                                                                {CompareData?.compare === true ? (
                                                                                    <input
                                                                                        className="px-2 form-check-input"
                                                                                        type="checkbox"
                                                                                        // disabled={q.isLocked === 0}
                                                                                        style={{
                                                                                            width: "20px",
                                                                                            height: "20px"
                                                                                        }}
                                                                                        checked={q.selected === 1}
                                                                                        onChange={(e) =>
                                                                                            handleCheckboxChange(
                                                                                                index,
                                                                                                quotationIndex,
                                                                                                e.target.checked
                                                                                            )
                                                                                        }
                                                                                    />
                                                                                ) : (
                                                                                    <input
                                                                                        className="px-2 form-check-input"
                                                                                        checked={q.selected === 1}
                                                                                        type="checkbox"
                                                                                        disabled
                                                                                        style={{
                                                                                            width: "20px",
                                                                                            height: "20px"
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                            </div>
                                                                        ) : null}
                                                                    </td>

                                                                    {/* Qty */}
                                                                    <td>
                                                                        <input
                                                                            style={{ width: "100%" }}
                                                                            className="p-1"
                                                                            type="text"
                                                                            disabled
                                                                            value={q?.qty ?? ""}
                                                                        />
                                                                    </td>

                                                                    {/* Unit Price */}
                                                                    <td>
                                                                        <input
                                                                            style={{ width: "100%" }}
                                                                            disabled={
                                                                                !q ||
                                                                                CompareData.doctype === "Comparison" ||
                                                                                q.isLocked === 0
                                                                            }
                                                                            className="p-1"
                                                                            type="number"
                                                                            onWheel={(e) => e.target.blur()}
                                                                            value={q?.unitPrice ?? ""}
                                                                            min={0}
                                                                            onKeyDown={preventNegativeSign}
                                                                            onChange={(e) =>
                                                                                handleTableChange(
                                                                                    index,
                                                                                    quotationIndex,
                                                                                    "unitPrice",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        />
                                                                    </td>

                                                                    {/* Amount */}
                                                                    <td>
                                                                        <input
                                                                            style={{ width: "100%" }}
                                                                            className="p-1"
                                                                            type="text"
                                                                            disabled
                                                                            value={
                                                                                q
                                                                                    ? Number(q.amount || 0).toFixed(
                                                                                        currencyPrecision?.exp1 || 3
                                                                                    )
                                                                                    : ""
                                                                            }
                                                                        />
                                                                    </td>

                                                                </React.Fragment>
                                                            );
                                                        })}
                                                    </tr>
                                                ))}

                                                {/* TOTAL */}
                                                <tr>
                                                    <td colSpan="6" className="m-0 p-0">
                                                        <input
                                                            className="p-1 w-100"
                                                            disabled
                                                            value="Total"
                                                        />
                                                    </td>

                                                    {rows?.[0]?.quotations?.map((q, index) => {

                                                        const supplierName =
                                                            typeof q?.supplier === "object"
                                                                ? q?.supplier?.label
                                                                : q?.supplier;

                                                        const supplier = supplierTotals?.[supplierName] || {
                                                            qty: 0,
                                                            amount: 0
                                                        };

                                                        return (
                                                            <React.Fragment key={index}>

                                                                <td>
                                                                    <input
                                                                        style={{ width: "100%" }}
                                                                        className="p-1"
                                                                        type="text"
                                                                        disabled
                                                                        value=""
                                                                    />
                                                                </td>

                                                                <td>
                                                                    <input
                                                                        style={{ width: "100%" }}
                                                                        className="p-1"
                                                                        type="text"
                                                                        disabled
                                                                        value={supplier.qty}
                                                                    />
                                                                </td>

                                                                <td>
                                                                    <input
                                                                        style={{ width: "100%" }}
                                                                        className="p-1"
                                                                        type="text"
                                                                        disabled
                                                                        value="--"
                                                                    />
                                                                </td>

                                                                <td>
                                                                    <input
                                                                        style={{ width: "100%" }}
                                                                        className="p-1"
                                                                        type="text"
                                                                        disabled
                                                                        value={Number(
                                                                            supplier.amount || 0
                                                                        ).toFixed(
                                                                            currencyPrecision?.exp1 || 3
                                                                        )}
                                                                    />
                                                                </td>

                                                            </React.Fragment>
                                                        );
                                                    })}
                                                </tr>

                                                {/* SUPPLIER TOTAL */}
                                                <tr>
                                                    <td colSpan="6" className="m-0 p-0">
                                                        <input
                                                            className="p-1 w-100"
                                                            disabled
                                                            value="Supplier Total"
                                                        />
                                                    </td>

                                                    {rows?.[0]?.quotations?.map((q, index) => {

                                                        const supplierName =
                                                            typeof q?.supplier === "object"
                                                                ? q?.supplier?.label
                                                                : q?.supplier;

                                                        return (
                                                            <React.Fragment key={index}>

                                                                <td>
                                                                    <input
                                                                        style={{ width: "100%" }}
                                                                        className="p-1"
                                                                        type="text"
                                                                        disabled
                                                                        value=""
                                                                    />
                                                                </td>

                                                                <td>
                                                                    <input
                                                                        style={{ width: "100%" }}
                                                                        className="p-1"
                                                                        type="text"
                                                                        disabled
                                                                        value=""
                                                                    />
                                                                </td>

                                                                <td>
                                                                    <input
                                                                        style={{ width: "100%" }}
                                                                        className="p-1"
                                                                        type="text"
                                                                        disabled
                                                                        value=""
                                                                    />
                                                                </td>

                                                                <td>
                                                                    <input
                                                                        style={{ width: "100%" }}
                                                                        className="p-1"
                                                                        type="text"
                                                                        disabled
                                                                        value={Number(
                                                                            suppliersTotals?.[supplierName] || 0
                                                                        ).toFixed(
                                                                            currencyPrecision?.exp1 || 3
                                                                        )}
                                                                    />
                                                                </td>

                                                            </React.Fragment>
                                                        );
                                                    })}
                                                </tr>
                                            </tbody>
                                        )}
                                    </table>
                                </div>
                            </div>
                        )}
                        {gridVisibility[1] && (
                            <AuthorizationList
                                usersDetails={usersDetails}
                                setUser={setUser}
                            />
                        )}
                        {gridVisibility[2] && (
                            <MessageList />
                        )}
                    </div>
                </div>
                <div>
                    {CompareData?.qotRecordId ?
                        <UpdateAttachment
                            documentNo={QuotationNo}
                            open={attachmentModal}
                            rows={attachments}
                            readOnly={CompareData?.eye}
                            onFileSelect={handleFileSelect}
                            onRemarkChange={handleRemarkChange}
                            onDelete={handleDelete}
                            onClose={closeModal}
                        />
                        :
                        <Attachment
                            documentNo={QuotationNo}
                            open={attachmentModal}
                            onClose={closeModal}
                            rows={attachments}
                            readOnly={isReadOnly}
                            onFileSelect={handleFileSelect}
                            onRemarkChange={handleRemarkChange}
                            onDelete={handleDelete}
                            onSave={handleUpload}
                        />
                    }
                </div>
                <Modal size="md"
                    show={docModal} onHide={() => setDocModal(false)}
                    backdrop="static"
                    contentLabel='Doc Id Modal'
                >
                    <Modal.Header closeButton>
                        <Modal.Title className="center">Quotation Number</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="text-danger">
                            The Quotation number already exists. Click "Generate" to assign a new number.
                        </p>
                    </Modal.Body>
                    <Modal.Footer className='end p-3'>
                        <button className='mainbtnGry' onClick={onCloseModal}>Cancel</button>
                        <button className='mainbtnRed' onClick={GenerateNumber}>Generate</button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div >
    )
}

export default PriceCompCreate